/*
 * @Author: your name
 * @Date: 2019-11-19 10:56:07
 * @LastEditTime : 2019-12-19 14:34:43
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /newOfficeIndex/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import './api/mock'
// import axios from '../node_modules/_axios@0.18.0@axios'
// import App from './components/chuangMeiQi'
import App from './components/dawingCommon'
// import router from './router/ptyIndex.js'
import axios from 'axios'
import router from './router/dawingIndex.js'
import {Carousel, Dropdown, CarouselItem, DropdownMenu, DropdownItem, Icon} from 'iview'
import {WOW} from 'wowjs'
import 'animate.css'
import 'iview/dist/styles/iview.css'
import titleContent from './components/DAWNING/titleContent'
// import detailInfo from './components/ptyPart/detailInfo'
import store from './store/store'
Vue.component('Carousel', Carousel)
Vue.component('CarouselItem', CarouselItem)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownMenu', DropdownMenu)
Vue.component('DropdownItem', DropdownItem)
Vue.component('Icon', Icon)
Vue.component('title-content', titleContent)
// Vue.component('detail-info', detailInfo)
// Vue.component('list-part', listPart)

new WOW({live: false}).init()
// import detailInfo from './components/part2/detailInfo'
// Vue.component('detail-info', detailInfo)

Vue.prototype.axios = axios
Vue.config.productionTip = false

Vue.filter('getWords', (a) => {
  let total = 80
  if (window.innerWidth < 800) {
    total = 30
  }
  if (a && a.length >= total) {
    return a.substring(0, total) + '...'
  } else {
    return a
  }
})
// 截断日期
Vue.filter('substrDate', (a) => {
  if (a.length > 10) {
    return a.substring(0, 10)
  } else {
    return a
  }
})
// console.log(Vue)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js